import { BRUSH_SIZES } from '../../constants/brushSizes'
import { usePaintStore } from '../../state/paintStore'
import './BrushSizePicker.css'

export function BrushSizePicker() {
  const brushSize = usePaintStore((s) => s.brushSize)
  const setBrushSize = usePaintStore((s) => s.setBrushSize)
  const color = usePaintStore((s) => s.color)

  return (
    <section className="brush-picker" aria-label="Brush size">
      {BRUSH_SIZES.map((size) => (
        <button
          key={size.id}
          type="button"
          className={`brush-option${brushSize.id === size.id ? ' is-active' : ''}`}
          onClick={() => setBrushSize(size.id)}
          aria-label={`${size.label} brush`}
          aria-pressed={brushSize.id === size.id}
        >
          <span
            className="brush-dot"
            style={{
              width: size.px,
              height: size.px,
              backgroundColor: color.hex,
            }}
          />
          <span className="brush-label">{size.label}</span>
        </button>
      ))}
    </section>
  )
}
